export default __webpack_public_path__ + "javascript.a04b75f2.png";